/* eslint-disable import/prefer-default-export */
import axios from "../Axios";

const module = "/program-messages";

export const getMessages = async (page) => {
  const { data } = await axios.get(`${module}/?page=${page}`);
  return data;
};
